import { ApolloCache } from "@apollo/client"

import { evict } from "shared/api/evict"
import { RoomTypename } from "shared/types/Project"

export function evictRoom(id: string, cache: ApolloCache<object>) {
  evict({
    cache,
    id,
    typename: RoomTypename
  })
}
